<birdz-modal>
  <div modal-title>{{ 'HEAVY_MAP_PROMPT_TITLE' | transloco }}</div>
  <div modal-body>
    <mat-dialog-content class="explanation" [innerHTML]="'HEAVY_MAP_PROMPT_EXPLANATION' | transloco">
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton="filled" (click)="onCancel()">{{ 'CANCEL' | transloco }}</button>
      <button matButton="filled" (click)="onConfirm()">
        {{ 'CONTINUE' | transloco }}
      </button>
    </mat-dialog-actions>
  </div>
</birdz-modal>
